module.exports = __webpack_public_path__ + "img/car_serve.91bd5f18.png";